/**
 * This file contains utility functions for feature flags.
 *
 * It exports the following functions:
 * - isFeatureEnabled: Function that returns a boolean indicating if a feature is enabled.
 * - identify: Function that identifies a user with PostHog.
 * - reset: Function that resets the PostHog instance.
 *
 * Example usage:
 * import { isFeatureEnabled } from '@/utils/feature-flag';
 *
 * const isMyFeatureEnabled = isFeatureEnabled('FOUND_people_custom_access');
 */

import { posthogInstance } from '@/plugins/posthog';
import { type IdentifyProperties } from '@/types/user';

const isFeatureEnabled = (featureKey: string) => !!posthogInstance.isFeatureEnabled(featureKey);
const identify = (userId: string, properties: IdentifyProperties) => posthogInstance.identify(userId, properties);
const reset = () => posthogInstance.reset();

export { identify, isFeatureEnabled, reset };
